import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IVendorACHDetails, IVendorFormOnly, IVendorProductModel, IVendorsFilterOptions } from '../Shared/model/VendorsModel';
import { IResponseModel } from '../Shared/model/CommonModel';

@Injectable({
  providedIn: 'root',
})

export class VendorService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  GetVendorById(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorInfoById?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorInfoByMarketVendorId(Id): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorInfoByMarketVendorId?vendorId=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorIdbyBoothNoForCurrentDay(boothNumber): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorIdbyBoothNoForCurrentDay?boothNumber=${boothNumber}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorMarketRentalStatus(vendorId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorMarketRentalStatus?vendorId=${vendorId}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorSearchList(filterOption: IVendorsFilterOptions): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/VendorSearchList`;
    return this.http.post<any>(url, filterOption, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(error => { return of([]); })
      );
  }

  deleteVendorById(vendorId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/DeleteVendorById?vendorId=${vendorId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorProductsById(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorProducts?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorBalances(vendorId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorBalances?vendorId=` + vendorId,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorDashboardById(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorDashboardById?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorInfoDetails(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorInfoDetails?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorNotesById(id: number, startDate?: string, endDate?: string): Observable<any[]> {
    let params = `?id=${id}`;
    if (startDate) params += `&startDate=${encodeURIComponent(startDate)}`;
    if (endDate) params += `&endDate=${encodeURIComponent(endDate)}`;
    return this.http.get<any[]>(
      `${this.baseURL}/Vendor/GetVendorNotesById${params}`,
      { observe: 'response' }
    ).pipe(
      map(res => res.body as any[]),
      catchError(this.handleError)
    );
  }

  UpdateVendorStatus(VendorStatus): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/UpdateVendorStatus`;
    return this.http.post<any>(url, VendorStatus, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  UpdateOrSaveVendorComment(VendorComment): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/UpdateVendorComments`;
    return this.http.post<any>(url, VendorComment, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }


  saveVendorNote(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/Vendor/SaveVendorNote`,
      data,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  deleteVendorNote(id: number): Observable<any> {
    return this.http.delete(`${this.baseURL}/Vendor/DeleteVendorNote/${id}`,
      {
        observe: 'response'
      }).pipe(
        map((res: HttpResponse<any>) => res.body),
        catchError(this.handleError)
      );
  }

  getVendorAttachmentsById(vendorId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorAttachmentsById?id=${vendorId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  saveVendorAttachment(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/Vendor/SaveVendorAttachment`,
      data,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getVendorAttachmentImage(imageUrl: string): Observable<Blob> {
    return this.http.get(
      `${this.baseURL}/Vendor/DownloadImage?imageUrl=${encodeURIComponent(imageUrl)}`,
      { responseType: 'blob' }
    ).pipe(
      catchError(this.handleError)
    );
  }


  GetMarketVendorSettings(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetMarketVendorSettings?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  UpdateMarketVendorSettings(VendorSetting): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/UpdateMarketVendorSettings`;
    return this.http.post<any>(url, VendorSetting, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  UpdateVendor(Vendor: IVendorFormOnly): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/UpdateVendorInfo`;
    return this.http.post<any>(url, Vendor, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  SaveVendor(Vendor: IVendorFormOnly): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/AddVendor`;
    return this.http.post<any>(url, Vendor, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorFormInfo(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorFormInfo?id=${Id}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getBookedAndReservedBoothVendorDetails(boothNumber): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetBookedAndReservedBoothVendorDetails?BoothNumber=${boothNumber}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  UpdateConsignmentOrFlatPosComm(comm): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/UpdateConsignmentOrFlatPosComm`;
    return this.http.post<any>(url, comm, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorByMarketVendorId(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorByMarketVendorId?Id=${Id}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorHistory(payload: {
    VendorId: number,
    FromDate?: string | null,
    ToDate?: string | null,
    OnlyWithPayment?: boolean,
    LatestCount?: number | null
  }): Observable<any[]> {

    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/GetVendorHistory`;

    return this.http.post<any[]>(url, payload, options)
      .pipe(
        map(res => res as any[]),
        catchError(this.handleError)
      );
  }

  GeneratePaymentReceipt(payload: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/GeneratePaymentReceipt`;

    return this.http.post<any>(url, payload, options)
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  DisplayDeleteRentalReceipt(payload: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/DisplayDeleteRentalReceipt`;

    return this.http.post<any>(url, payload, options)
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  DisplayVoidReceipt(payload: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/DisplayVoidReceipt`;

    return this.http.post<any>(url, payload, options)
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetVoidReceiptDataForThermal(payload: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/GetVoidReceiptDataForThermal`;

    return this.http.post<any>(url, payload, options)
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorContracts(vendorId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorContractsById?vendorId=${vendorId}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  GenerateContractForAccount(accountReceiptId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/PaymentReceipt/GenerateContractForAccount?accountReceiptId=${accountReceiptId}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getVendorContactPersons(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorContactPersons?id=${id}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  saveVendorContactPerson(data: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/SaveVendorContactPerson`;
    return this.http.post<any>(url, data, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  UpdateVendorACHDetails(vendorACHDetails: IVendorACHDetails): Observable<IResponseModel> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/UpdateVendorACHDetails`;
    return this.http.post<IResponseModel>(url, vendorACHDetails, options)
      .pipe(
        map(res => {
          const response = res as IResponseModel;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getVendorComment(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorComments?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorByBoothNumber(boothNumber: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorByBoothNumber?boothNumber=${boothNumber}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any; // ResponseModel
        return result;
      }),
      catchError(this.handleError)
    );
  }

  updateCurrentMonthWebUsers(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/UpdateCurrentMonthWebUsers`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  GetStateAndCityByZipcode(zipcode: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetStateAndCityByZipcode?zipcode=${zipcode}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  getVendorEmailList(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Vendor/GetVendorEmailList`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  sendVendorEmails(sendVendorEmailRequest: any): Observable<any> {
    const url = `${this.baseURL}/Vendor/SendVendorEmails`;
    return this.http.post<any>(url, sendVendorEmailRequest, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  changeMarketVendorId(oldVendorId: string, newVendorId: string): Observable<any> {
    return this.http.get(
      `${this.baseURL}/Vendor/ChangeMarketVendorId?VendorId=${encodeURIComponent(oldVendorId)}&NewMarketVendorId=${encodeURIComponent(newVendorId)}`,
      { observe: 'response', responseType: 'text' }
    ).pipe(
      map(res => {
        try {
          return res.body ? JSON.parse(res.body) : null;
        } catch {
          return null;
        }
      }),
      catchError(this.handleError)
    );
  }

  HasVendorTransactionsAfterLastPayout(vendorId: number): Observable<any> {
    return this.http.get(
      `${this.baseURL}/Vendor/HasVendorTransactionsAfterLastPayout?vendorId=${vendorId}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  UpdateVendorFlatCommission(model: any): Observable<any> {
    const url = `${this.baseURL}/Vendor/UpdateVendorFlatCommission`;
    return this.http.post<any>(url, model, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  UpdateDefaultVendorCommissions(model: any): Observable<any> {
    const url = `${this.baseURL}/Vendor/UpdateDefaultVendorCommissions`;
    return this.http.post<any>(url, model, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  SaveOrUpdateVendorProducts(vendorProductsList: IVendorProductModel[], vendorId: number): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Vendor/SaveOrUpdateVendorProducts`;
    return this.http.post<any>(url, { vendorProductsList: vendorProductsList, vendorId: vendorId }, options
    ).pipe(
      map(res => {
        const response = res as any[];
        return response;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
